import React, { useState, useEffect } from "react";
import { Box, Button, Heading, Icon, Text, VStack, useColorModeValue, SimpleGrid } from "@chakra-ui/react";
import { FaCalculator, FaFlask, FaBook, FaDesktop, FaGlobe } from "react-icons/fa";
import { useLazyQuery } from "@apollo/client";
import { useStore } from "../../Store";
import {
  GRADES_SUBJECTS
} from "../../graphql/queries";
import { PK12Skeleton } from "../PK12Skeleton";

const subjects = {
  'English': { icon: FaBook, title: 'English' },
  'Science': { icon: FaFlask, title: 'Science' },
  'Maths': { icon: FaCalculator, title: 'Mathematics' },
  'Social Studies': { icon: FaGlobe, title: 'Social Studies' },
  'Computers': { icon: FaDesktop, title: 'Computers' },
}

export const PK_12 = ({ product, type: productType }) => {

  const [dynoGrades, setDynoGrades] = useState([]);
  const [dynoSubjects, setDynoSubjects] = useState([]);
  const {updateStates} = useStore((state) => state);

  const [getDynosGradesSubjects, {loading}] = useLazyQuery(GRADES_SUBJECTS,
    {
      onCompleted: (data) => {
        setDynoGrades(data.dynoGrades.filter(dg => (dg.name !== "Pre-K" && dg.name !== "Nursery" && dg.name !== "LKG" && dg.name !== "UKG")))
        setDynoSubjects(
          data.dynoSubjects
            .filter(ds => (ds.name === "English" || ds.name === "Science" || ds.name === "Social Studies" || ds.name === "Computers" || ds.name === "Maths"))
            .map(dc => ({
              ...dc,
              ...subjects[dc.name]
            }))
        )
      },
    }
  )

  const cardBg = useColorModeValue("white", "gray.700");

  const toggleGradeSelection = (type, id) => {

    if (type === "grade") {
      const grades = [...product.grades]
      updateStates({
        [productType]: {...product, 
          grades: grades.includes(id)
          ? grades.filter((g) => g !== id)
          : [...grades, id]
        }
      })
    } else {
      updateStates({
        [productType]: {
          ...product, 
          subject: id
        }
      })
    }
  };

  useEffect(() => {
    getDynosGradesSubjects()
  }, []);

  return (
    loading ?
    <PK12Skeleton /> :
    <Box w="100%">
      <Heading as='h3' size='lg' mb={4}>K12 Course Settings</Heading>
      <Text fontSize="md" mb={8} color="gray.600">Select grade level and subject for your K12 course</Text>

      <Box bg={cardBg} p={8} rounded="lg" shadow="md">
        <VStack align="start" spacing={6}>

          {/* Grade Selection */}
          <Box w="100%">
            <Text fontSize="lg" fontWeight="semibold" mb={4}>Grade Level</Text>
            <SimpleGrid minChildWidth='120px' spacing={4}>
              {dynoGrades?.map((grade) => (
                <Button
                  key={grade.id}
                  onClick={() => toggleGradeSelection("grade", grade.id)}
                  colorScheme="blue"
                  variant={product.grades.includes(grade.id) ? "solid" : "outline"}
                >
                  <Text as="span" fontSize="sm">{grade.name}</Text>
                </Button>
              ))}
            </SimpleGrid>
          </Box>

          {/* Subject Selection */}
          <Box w="100%">
            <Text fontSize="lg" fontWeight="semibold" mb={4}>Subject</Text>
            <SimpleGrid minChildWidth='120px' spacing={4}>
              {dynoSubjects?.map((subject) => (
                <Button
                  key={subject.id}
                  onClick={() => toggleGradeSelection("subject", subject.id)}
                  variant={product.subject === subject.id ? "solid" : "outline"}
                  colorScheme="blue"
                >
                  <Icon as={subject.icon} color={product.subject === subject.id ? "white" : "blue.500"} mr={2} />
                  <Text as="span" fontSize="sm">{subject.name}</Text>
                </Button>
              ))}
            </SimpleGrid>
          </Box>
        </VStack>
      </Box>
    </Box>
  );
};
